import { render, staticRenderFns } from "./TabDetalheMonitoramentoRfidList.vue?vue&type=template&id=54ad71c7&scoped=true"
import script from "./TabDetalheMonitoramentoRfidList.vue?vue&type=script&lang=js"
export * from "./TabDetalheMonitoramentoRfidList.vue?vue&type=script&lang=js"
import style0 from "./TabDetalheMonitoramentoRfidList.vue?vue&type=style&index=0&id=54ad71c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ad71c7",
  null
  
)

export default component.exports